export const productionHost = 'https://manage.aws.yamato-gp.net';
export const stagingHost = 'https://staging.manage.aws.yamato-gp.net';

export function hostUrl() {
  if (import.meta.env.RAILS_ENV === 'production') {
    return productionHost;
  } else {
    return stagingHost;
  }
}

const transactionsPath = '/kanri/satei_db/transactions';

function csrfToken() {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  if (!token) {
    throw new Error('CSRF token is missing');
  }

  return token;
}

async function jsonResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error('Satei DB proxy returned an invalid response');
  }

  let body;
  try {
    body = await response.json();
  } catch {
    throw new Error('Satei DB proxy returned an invalid response');
  }

  if (!response.ok) {
    const message = body?.error?.message;
    throw new Error(
      typeof message === 'string'
        ? message
        : `Satei DB request failed (${response.status})`
    );
  }

  return body;
}

export async function sateiDbCreatePost(params) {
  const response = await fetch(transactionsPath, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    body: JSON.stringify(params),
  });

  return jsonResponse(response);
}

export async function sateiDbItemGet(id) {
  const response = await fetch(
    `${transactionsPath}/${encodeURIComponent(id)}`,
    {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }
  );

  return jsonResponse(response);
}

export function transactionIdUrl(id) {
  return `${hostUrl()}/satei/?transaction_id=${id}`;
}

export function dealingIdUrl(id) {
  return `${hostUrl()}/transactions/${id}/`;
}
